module.exports = __webpack_public_path__ + "static/media/fox_0.17ab7e13.png";